export const STATUS = {
    draft: "draft",
    pending: "pending",
    running: "running",
    completed: "completed"
};

export const DASHBOARD_CONFIG_ARRAY = [
    {
        key: "all",
        label: "All Tests",
        wevoFilter: wevo => !wevo.isArchived,
        queryString: "draft,pending,running,completed"
    },
    {
        key: "drafts",
        label: "Drafts",
        wevoFilter: wevo =>
            (wevo.status === "draft" || wevo.status === "pending") &&
            !wevo.isArchived,
        queryString: "draft"
    },
    {
        key: "running",
        label: "Running",
        wevoFilter: wevo => wevo.status === "running" && !wevo.isArchived,
        queryString: "running,pending"
    },
    {
        key: "finished",
        label: "Finished",
        wevoFilter: wevo => wevo.status === "completed" && !wevo.isArchived,
        queryString: "completed"
    },
    {
        key: "archived",
        label: "Archived",
        wevoFilter: wevo => wevo.isArchived,
        queryString: "archived"
    }
];

export const DASHBOARD_CONFIG_DICT = DASHBOARD_CONFIG_ARRAY.reduce(
    (dict, config) => {
        dict[config.key] = config;
        return dict;
    },
    {}
);

export const STATUS_LABELS = {
    archived: "Archived",
    completed: "Finished",
    draft: "Draft",
    running: "Running",
    pending: "Pending ..."
};

export function inProgress(status) {
    return status === STATUS.pending || status === STATUS.running;
}



// WEBPACK FOOTER //
// ./src/modules/wevos/constants.js